module.exports = __webpack_public_path__ + "img/car-entrega.8e084b00.svg";